/**
 * Detecta o tipo de documento baseado no nome/descrição do arquivo
 * @param {Object} arquivo - Objeto contendo descricao ou nome
 * @returns {string} Tipo do documento
 */
export const detectarTipoDocumento = (arquivo) => {
  const nome = (arquivo.descricao || arquivo.nome || '').toLowerCase();
  
  // Notas Fiscais - verificar se contém qualquer destes padrões
  const padroesNf = ['nota fiscal', 'nf', 'fatura'];
  if (padroesNf.some(padrao => nome.includes(padrao))) {
    return 'notas_fiscais';
  }
  
  // Contratos - verificar se contém qualquer destes padrões
  const padroesContratos = ['contrato', 'ccb', 'emprestimo'];
  if (padroesContratos.some(padrao => nome.includes(padrao))) {
    return 'contratos';
  }
  
  // Comprovantes
  const padroesComprovantes = ['comprovante', 'recibo'];
  if (padroesComprovantes.some(padrao => nome.includes(padrao))) {
    return 'comprovantes';
  }
  
  // Boleto
  if (nome.includes('boleto')) {
    return 'boleto';
  }
  
  // Energia
  const padroesEnergia = ['energia', 'eletrica', 'luz'];
  if (padroesEnergia.some(padrao => nome.includes(padrao))) {
    return 'energia';
  }
  
  // Aluguel
  const padroesAluguel = ['aluguel', 'locacao'];
  if (padroesAluguel.some(padrao => nome.includes(padrao))) {
    return 'aluguel';
  }
  
  return 'outros';
};

